import React, { Component } from 'react';
import { translate } from 'react-i18next';
import config from '../config';

import { Table, Checkbox, Button } from 'react-bootstrap';
import Moment from 'moment';
import Dialog from 'react-bootstrap-dialog';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Link } from 'react-router-dom';
import Switch from 'react-switch';
import TooltipButton from './TooltipButton';

import './TemplateMediaTable.css';

class TemplateMediaTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isDragging: false,
			medialibraryuuid: this.props.medialibraryuuid,
			organisationuuid: this.props.organisationuuid,
			media: this.props.media || [],
			itemsSelected: this.props.itemsSelected
		};
	}

	handleCopyClicked(media) {
		this.props.onCopyClicked(media);
	}

	humanFileSize(bytes, si) {
		var thresh = si ? 1000 : 1024;
		if (Math.abs(bytes) < thresh) {
			return bytes + ' B';
		}
		var units = si ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
		var u = -1;
		do {
			bytes /= thresh;
			++u;
		} while (Math.abs(bytes) >= thresh && u < units.length - 1);
		return bytes.toFixed(1) + ' ' + units[u];
	}

	componentWillReceiveProps(newProps) {

		console.log(newProps.organisationuuid);
		this.setState({
			medialibraryuuid: newProps.medialibraryuuid,
			organisationuuid: newProps.organisationuuid,
			media: newProps.media || [],
			itemsSelected: newProps.itemsSelected
		});
	}

	toggleSelected(media) {
		this.props.onSelectionChanged(media, !this.getCheckedState(media));
	}

	onBeforeDragStart = () => {
		this.setState({
			isDragging: true
		});
	};

	onDragEnd = result => {
		this.setState({
			isDragging: false
		});

		// dropped outside the list
		if (!result.destination || result.destination.index === result.source.index) {
			return;
		}

		// no movement
		if (result.destination.index === result.source.index) {
			return;
		}

		this.props.onDragEnd(result);
	};

	getCheckedState(media) {
		return this.state.itemsSelected.includes(media);
	}

	handleSwitchChange(checked, media) {
		console.log('click: ' + media.uuid);
		this.props.onEnabledChanged(media, checked);
	}

	handleCheckBoxChange = event => {
		const target = event.target;

		const checked = target.checked;
		const uuid = target.name;

		const media = this.state.media.find(media => {
			return media.uuid === uuid;
		});

		this.props.onSelectionChanged(media, checked);
	};

	render() {
		const noPropagation = e => e.stopPropagation();

		const { t, medialibraryuuid, organisationuuid } = this.props;

		const getItemStyle = (isDragging, draggableStyle) => ({
			// some basic styles to make the items look a bit nicer
			userSelect: 'none',
			background: isDragging ? '#dddddd' : '',
			display: isDragging ? 'table' : '',
			...draggableStyle
		});

		const getListStyle = isDraggingOver => ({
			borderCollapse: isDraggingOver ? 'separate' : 'collapse'
		});

		let mediaRows = this.state.media.map((media, index) => {
			return (
				<Draggable key={media.uuid} draggableId={media.uuid} index={index}>
					{(provided, snapshot) => (
						<tr
							ref={provided.innerRef}
							{...provided.draggableProps}
							{...provided.dragHandleProps}
							onClick={e => {
								e.stopPropagation();
								this.toggleSelected(media);
							}}
							style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
						>
							<td width='20'>
								<Checkbox checked={this.getCheckedState(media)} name={media.uuid} onChange={this.handleCheckBoxChange} />
							</td>
							<td width='150'>
								{media.uploaded ? (
									<a onClick={noPropagation} href={`${config.playersBaseURL}/mediaserver/media/${organisationuuid}/${medialibraryuuid}/${media.uuid}.${media.extension}`} className='thumbnail' target='_blank'>
										<img src={`${config.playersBaseURL}/mediaserver/thumbnails/${organisationuuid}/${medialibraryuuid}/${media.uuid}.jpg`} width='150' />
									</a>
								) : (
										<img src={`${config.imagesBaseURL}/misc/processing_spinner.gif`} width='150' />
									)}
							</td>
							<td width='150' className='hidden-xs'>
								{media.name}
							</td>
							<td width='75' className='hidden-xs hidden-sm'>
								<span className='label label-default'>{media.extension}</span>
							</td>
							<td width='75' className='hidden-xs hidden-sm'>
								<span className='label label-default'>{this.humanFileSize(media.filesize, true)}</span>
							</td>

							<td width='150' className='hidden-xs hidden-sm'>
								{Moment(media.updatedAt).format('YYYY-MM-DD HH:mm')}
							</td>
							<td className='hidden-xs hidden-sm'>
								{Moment(media.createdAt).format('YYYY-MM-DD HH:mm')}
							</td>

							<td align='center' width='230'>
								<div className='btn-toolbar pull-right'>
									<TooltipButton
										disabled={this.state.isDragging}
										className='btn-danger'
										onClick={e => {
											e.stopPropagation();
											this.props.onDeleteMedia(media);
										}}
										tooltip={t('Dialog.delete')}
									>
										<em className='fas fa-trash' />
									</TooltipButton>
								</div>
							</td>
						</tr>
					)}
				</Draggable>
			);
		});

		return (
			<div className='TemplateMediaTable'>
				<Dialog
					ref={el => {
						this.dialog = el;
					}}
				/>
				<DragDropContext onBeforeDragStart={this.onBeforeDragStart} onDragEnd={this.onDragEnd}>
					<Droppable droppableId='droppable'>
						{(provided, snapshot) => (
							<table style={getListStyle(snapshot.isDraggingOver)} ref={provided.innerRef} className='table table-striped'>
								<thead>
									<tr>
										<th width='20' />
										<th width='150'>{t('TemplateMediaTable.thumbnail')}</th>
										<th width='150' className='hidden-xs'>
											{t('TemplateMediaTable.filename')}
										</th>
										<th width='75' className='hidden-xs hidden-sm'>
											{t('TemplateMediaTable.extension')}
										</th>
										<th width='100' className='hidden-xs hidden-sm'>
											{t('TemplateMediaTable.filesize')}
										</th>
										<th width='150' className='hidden-xs hidden-sm'>
											{t('TemplateMediaTable.updated')}
										</th>
										<th className='hidden-xs hidden-sm'>{t('TemplateMediaTable.uploaded')}</th>
										<th>
											<em className='fa fa-cog' />
										</th>
									</tr>
								</thead>
								<tbody>{mediaRows}</tbody>
							</table>
						)}
					</Droppable>
				</DragDropContext>
			</div>
		);
	}
}

export default translate('translations')(TemplateMediaTable);
